document.addEventListener('DOMContentLoaded', function() {
    // Проверяем, существуют ли кнопки вкладок, перед добавлением обработчиков событий
    const buttons = document.querySelectorAll('.tabs__button');
    if(buttons.length > 0) {
        buttons.forEach(function(button) {
            button.addEventListener('click', function() {
                // Повторно проверяем наличие кнопок перед их обновлением
                const allButtons = document.querySelectorAll('.tabs__button');
                if(allButtons.length > 0) {
                    allButtons.forEach(function(btn) {
                        btn.classList.remove('tabs__button--active');
                    });
                }

                // Повторно проверяем наличие элементов контента перед их обновлением
                const contentItems = document.querySelectorAll('.tabs__content-item');
                if(contentItems.length > 0) {
                    contentItems.forEach(function(item) {
                        item.classList.remove('tabs__content-item--active');
                    });
                }

                button.classList.add('tabs__button--active');
                // Проверяем, существует ли целевой элемент контента перед добавлением активного класса
                const targetId = button.getAttribute('data-target');
                const targetElement = document.getElementById(targetId);
                if(targetElement) {
                    targetElement.classList.add('tabs__content-item--active');
                }
            });
        });
    }
});
